<template>
    <div id="perspective-active-sidebar-menu" class="sidebar-menu-container">
        <div class="sidebar-main-label">Задание перспективы</div>
        <div class="sidebar-text-area">Переместите
            <span class="red-text bold-text">точки плоскости</span> таким образом, чтобы образующие её
            <span class="red-text bold-text">отрезки</span> совпадали с видимыми на фотографии
            <span class="red-text bold-text">линиями перспективы.</span></div>
        <div class="sidebar-step-two-img-container">
            <img class="sidebar-step-two-img" :src="urlForStatic('/img/perspective_lines.png')"/>
        </div>
        <div class="sidebar-text-area bold-text">
            Рекомендация:
        </div>
        <div class="sidebar-text-area">
            Для корректного отображения <span class="red-text bold-text">одного материала</span> на
            <span class="red-text bold-text">разных отрезках стены</span>, находящихся в
            <span class="red-text bold-text">одной плоскости</span>, линии перспективы должны
            <span class="red-text bold-text">совпадать</span>.
        </div>
        <div class="sidebar-step-two-img-container">
            <img class="sidebar-step-two-img" :src="urlForStatic('/img/perspective_tip.png')"/>
        </div>
    </div>
</template>

<script>
    import {urlForStaticVue} from "../../common";

    export default {
        name: "PerspectiveActiveInstructionsSidebarMenu",
        mixins: [urlForStaticVue]
    }
</script>

<style scoped>

</style>
